import { render, staticRenderFns } from "./ChristmasDestockingBanner.vue?vue&type=template&id=9bb0c898&name=christmas-destocking-banner&"
import script from "./ChristmasDestockingBanner.vue?vue&type=script&lang=js&"
export * from "./ChristmasDestockingBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasDestockingBanner.vue?vue&type=style&index=0&id=9bb0c898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports